import React from 'react';
export function FinalCta() {
  return <section className="py-12 md:py-16 px-5 text-center bg-[radial-gradient(ellipse_at_center,rgba(107,0,182,0.4)_0%,transparent_70%),linear-gradient(180deg,var(--card-bg),var(--dark-bg))]" data-id="element-38">
      <div className="max-w-[900px] mx-auto" data-id="element-39">
        <h2 className="text-[clamp(2rem,5vw,3.5rem)] font-heading font-black max-w-[750px] mx-auto mb-5 leading-[1.2]" data-id="element-40">
          El ciclo tiene una salida.
          <br data-id="element-41" />
          <span className="text-gradient-magenta" data-id="element-42">Hoy puede ser el día.</span>
        </h2>

        <p className="text-[1.1rem] text-white/75 max-w-[550px] mx-auto mb-8 leading-[1.7]" data-id="element-43">
          Llevas tiempo siendo fuerte.
          <br data-id="element-44" />
          Ahora prueba ser estratégico/a.
        </p>

        <a href="#oferta" className="inline-block bg-gradient-to-br from-magenta to-magenta-bright text-white font-heading font-extrabold text-[1.1rem] py-[22px] px-[55px] rounded-full uppercase tracking-[1px] shadow-[0_8px_30px_rgba(194,0,111,0.5),0_0_60px_rgba(194,0,111,0.2)] transition-all duration-300 hover:-translate-y-[3px] hover:shadow-[0_12px_40px_rgba(194,0,111,0.7),0_0_80px_rgba(194,0,111,0.3)]" data-id="element-45">
          → EMPIEZO HOY — ACCEDER A LA COLECCIÓN
        </a>

        <p className="mt-5 text-[0.85rem] text-white/40" data-id="element-46">
          Acceso inmediato · Pago seguro · 4 volúmenes completos
        </p>
      </div>
    </section>;
}